// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_lkyzB","breadcrumbs":"breadcrumbs_xap6i"};